export function dateFormat(format, inputDateStr) {
    // 从格式中识别分隔符
    const separator = format.match(/[^YMD]/); // 获取第一个非字母字符作为分隔符
    const sep = separator ? separator[0] : ''; // 如果没有分隔符，默认为空字符串

    if (inputDateStr.match(/^\d{8}$/)) {
        // 如果是8位数字日期
        // 将 YYYYMMDD 转换为 YYYY<sep>MM<sep>DD
        const year = inputDateStr.substring(0, 4);
        const month = inputDateStr.substring(4, 6);
        const day = inputDateStr.substring(6, 8);

        return `${year}${sep}${month}${sep}${day}`; // 使用分隔符构建日期
    } else if (inputDateStr.match(/^[\u4e00-\u9fa5]+$/)) {
        // 如果是中文字符串
        return inputDateStr; // 原样返回
    } else {
        console.warn('Invalid input format');
        return inputDateStr; // 如果输入不符合预期，原样返回
    }
}

export function process(value, fixed = 2, isZero) {
    if (value) {
        if (!isNaN(value)) {
            value = Number(value);
            let len = parseInt(Math.abs(value), 10).toString().length;
            value =
                (len > 12 && value / 1000000000000) ||
                (len > 8 && value / 100000000) ||
                (len > 4 && value / 10000) ||
                value;
            if (
                !isZero ||
                (!/^[-+]?\d*$/.test(value.toString()) &&
                    value.toString().split('.')[1].length > fixed)
            ) {
                value = value.toFixed(fixed);
            }
            value =
                (len > 12 && value + '万亿') ||
                (len > 8 && value + '亿') ||
                (len > 4 && value + '万') ||
                value;
        }
    } else if (value === 0) {
        value = '0.00';
    } else {
        value = '--';
    }

    return value;
}

//获取数组中最大值
export function getMax(arr) {
    arr = arr.filter(Boolean);
    if (!arr.length) return 0;
    let t = parseFloat(arr[0] || 0);
    for (let i = 0; i < arr.length; i++) {
        let e = parseFloat(arr[i] || 0);
        if (Object.is(e, NaN)) {
            continue;
        }
        if (e > t) {
            t = e;
        }
    }
    return t;
}

//获取数组中最小值
export function getMin(arr) {
    arr = arr.filter(Boolean);
    let t = parseFloat(arr[0] || 0);
    for (let i = 0; i < arr.length; i++) {
        let e = parseFloat(arr[i] || 0);
        if (Object.is(e, NaN)) {
            continue;
        }
        if (e < t) {
            t = e;
        }
    }
    return t;
}

/*
 * 获取某个元素下标
 * arr: 传入的数组
 * obj: 需要获取下标的元素
 * */
export function getArrayIndex(arr, obj) {
    var i = arr.length;
    while (i--) {
        if (arr[i] === obj) {
            return i;
        }
    }
    return -1;
}

//数组去掉空值
export function trimSpace(array) {
    for (var i = 0; i < array.length; i++) {
        if (array[i] == '' || array[i] == null || typeof array[i] == 'undefined') {
            array.splice(i, 1);
            i = i - 1;
        }
    }

    return array;
}
//函数拷贝
export function copyObj(obj = {}) {
    //变量先置空
    let newobj = null;

    //判断是否需要继续进行递归
    if (typeof obj == 'object' && obj !== null) {
        newobj = obj instanceof Array ? [] : {};
        //进行下一层递归克隆
        for (var i in obj) {
            newobj[i] = copyObj(obj[i]);
        }
        //如果不是对象直接赋值
    } else {
        newobj = obj;
    }

    return newobj;
}

//数组深拷贝
export function deepCopy(arr) {
    let newArr = [];
    for (let i = 0; i < arr.length; i++) {
        if (Array.isArray(arr[i])) {
            newArr[i] = deepCopy(arr[i]);
        } else {
            newArr[i] = arr[i];
        }
    }
    return newArr;
}

//查找元素在数组的位置
export function arrIndexOf(arr, item) {
    return arr.indexOf(item);
}

//获取两个数之间的随机整数
export function getRandomNumberByRange(start, end) {
    return Math.floor(Math.random() * (end - start) + start);
}

//JS转换时间戳为“刚刚”、“1分钟前”、“2小时前”“1天前”等格式
export function releaseTime(stringTime) {
    let t;
    if (stringTime.length > 10) {
        t = stringTime;
    } else {
        t = stringTime * 1000;
    }

    var minute = 1000 * 60;
    var hour = minute * 60;
    var day = hour * 24;
    var week = day * 7;
    var month = day * 30;
    var time1 = new Date().getTime() + 2000; //当前的时间戳
    var time2 = Date.parse(new Date(t)); //指定时间的时间戳
    var time = time1 - time2;

    var result = null;
    if (time / month >= 1 || time / week >= 1) {
        result = dateFormat('YYYY-MM-DD', stringTime);
    } else if (time / day >= 1) {
        result = parseInt(time / day) + '天前';
    } else if (time / hour >= 1) {
        result = parseInt(time / hour) + '小时前';
    } else if (time / minute >= 1) {
        result = parseInt(time / minute) + '分钟前';
    } else {
        result = '刚刚';
    }
    return result;
}

//JS 判断以指定字符串结尾
export function endWith(str, endStr) {
    str = str.trim();
    let d = str.length - endStr.length;

    return d >= 0 && str.lastIndexOf(endStr) == d;
}

//JS 数组去重
export function noRepeat(arr) {
    let newArr = [];
    for (let i = 0; i < arr.length; i++) {
        if (!newArr.includes(arr[i])) {
            newArr.push(arr[i]);
        }
    }
    return newArr;
}

//返回股票涨幅对应的颜色
export function judgeColor(n) {
    if (n == 0) {
        return 'gray';
    } else if (n > 0) {
        return 'red';
    } else if (n < 0) {
        return 'green';
    }
}

//返回股票涨幅对应的背景颜色
export function judgeBgColor(n) {
    if (n == 0) {
        return 'bg_gray';
    } else if (n > 0) {
        return 'bg_red';
    } else if (n < 0) {
        return 'bg_green';
    }
}

export function toFixedNum(value, toFixed = 2, unit = '', isJudge = false) {
    if (value && value !== '--') {
        if (isJudge) {
            if(Number(value) > 0) {
                 return '+' + Number(value).toFixed(toFixed) + unit;
            } else {
                return Number(value).toFixed(toFixed) + unit;
            }
        } else {
            return Number(value).toFixed(toFixed) + unit;
        }
    } else if (value === 0) {
        return '0.00' + unit;
    } else {
        return '--';
    }
}

//金额单位转换
export function unitTransition(value, lng) {
    lng = lng || 2;
    var s = value;
    if (value < 0) {
        value = Math.abs(value);
    }
    var newValue = ['', '', ''];
    var fr = 1000;
    var num = 3;
    var text1 = '';
    var fm = 1;
    while (value / fr >= 1) {
        fr *= 10;
        num += 1;
    }
    if (num <= 4) {
        // 千
        newValue[0] = downFixed(value, lng);
    } else if (num <= 8) {
        // 万
        text1 = '万';
        fm = text1 === '万' ? 10000 : 10000000;
        if (value % fm === 0) {
            newValue[0] = downFixed(value / fm, lng) + '';
        } else {
            newValue[0] = parseFloat(value / fm).toFixed(2) + '';
        }
        newValue[1] = text1;
    } else if (num <= 16) {
        // 亿
        text1 = (num - 8) / 3 > 1 ? '千亿' : '亿';
        text1 = (num - 8) / 4 > 1 ? '万亿' : text1;
        text1 = (num - 8) / 7 > 1 ? '千万亿' : text1;
        fm = 1;
        if (text1 === '亿') {
            fm = 100000000;
        } else if (text1 === '千亿') {
            fm = 100000000000;
        } else if (text1 === '万亿') {
            fm = 1000000000000;
        } else if (text1 === '千万亿') {
            fm = 1000000000000000;
        }
        if (value % fm === 0) {
            newValue[0] = downFixed(value / fm, lng) + '';
        } else {
            newValue[0] = parseFloat(value / fm).toFixed(lng) + '';
        }
        newValue[1] = text1;
    }
    if (value < 1000) {
        newValue[0] = downFixed(value, lng) + '';
        newValue[1] = '';
    }

    if (s < 0) {
        return '-' + newValue.join('');
    } else if (!s || s == 0) {
        return 0;
    } else if (s > 0) {
        return newValue.join('');
    }
}

//向下保留n位小数
export function downFixed(num, fix) {
    fix = fix || 0;
    // num为原数字，fix是保留的小数位数
    var result = '0';
    if (Number(num) && fix > 0) {
        // 简单的做个判断
        fix = +fix || 2;
        num = num + '';
        if (/e/.test(num)) {
            // 如果是包含e字符的数字直接返回
            result = num;
        } else if (!/\./.test(num)) {
            // 如果没有小数点
            result = num + '.' + Array(fix + 1).join('0');
        } else {
            // 如果有小数点
            num = num + Array(fix + 1).join('0');
            var reg = new RegExp('-?\\d*.\\d{0,' + fix + '}');
            // var reg = new RegExp(`-?\\d*.\\d{0,${fix}}`)
            result = reg.exec(num)[0];
        }
    } else if (fix == 0) {
        result = num;
    }

    return result;
}

/**
 * 日期时间格式化
 * @param {Object} dateTime 需要格式化的日期时间
 * @param {String} pattern  格式化的模式，如yyyy-MM-dd hh(HH):mm:ss.S a k K E D F w W z Z
 */
export function formtTime(dateTime, pattern) {
    var date = dateTime;
    var fmt = pattern;
    var o = {
        'M+': date.getMonth() + 1, //月份
        'd+': date.getDate(), //日
        'h+': date.getHours(), //小时
        'm+': date.getMinutes(), //分
        's+': date.getSeconds(), //秒
        'q+': Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp('(' + k + ')').test(fmt))
            fmt = fmt.replace(
                RegExp.$1,
                RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
            );
    return fmt;
}

/**
 * 去掉股票代码前两位
 * @param {股票代码} StockObj
 */
export function formatStock(StockObj) {
    if (StockObj) {
        return StockObj.substr(2, 6);
    } else {
        return '--';
    }
}

/**
 * 判断当前的值是否存在一个数组里面
 * value 需要配判断的值
 * array 要查找的数组
 */

export function isInArray(value, array) {
    return array.includes(value);
}

/**
 * 判断当前的值是否存在一个数组里面
 * value 需要删除的值
 * arr 要查找的数组
 */
export function removeValueFromArray(arr, value) {
    for (var i = 0; i < arr.length; i++) {
        // 判断元素是否为对象
        if (typeof arr[i] === 'object' && arr[i] !== null) {
            // 判断对象中是否包含特定值（松散比较）
            if (Object.values(arr[i]).some((val) => val == value)) {
                arr.splice(i, 1);
                i--;
            }
        } else if (arr[i] == value) {
            // 松散比较
            arr.splice(i, 1);
            i--;
        }
    }

    return arr;
}

/**
 * 把str  20220202 格式化 2022-02-02
 * @param {*} str
 * @returns
 */
export function formatStrTime(str) {
    if (str) {
        return str.substr(0, 4) + '-' + str.substr(4, 2) + '-' + str.substr(6, 2);
    } else {
        return '--';
    }
}

/**
 * 把整数 转换成金额3个带逗号
 * @param {*} number 金额整数
 */
export function moneyFormat(number) {
    if (number) {
        return String(number).replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
    } else {
        return '--';
    }
}

/**
 * 百分比 乘 100 并且转正比
 * @param {} floatInfo
 */
export function formatPositive(floatInfo) {
    var i = floatInfo * 100 * 1;
    return parseInt(Math.abs(i));
}

/**
 * 字符串吧(,逗号) 替换成 (天、)
 * @param {*} str
 * @returns
 */
export function formatStrToStr(str) {
    if (str) {
        var vDate = str.replace(/,/g, '天、');
        vDate = vDate + '天、';
        vDate = vDate.slice(0, vDate.length - 1);
        return vDate;
    } else {
        return '';
    }
}

// 将时间戳或日期字符串转换为指定格式的日期字符串，可以自定义日期中的连接符
export function formatDate(date, formatStr) {
    // 如果传入的是时间戳，将其转换为日期对象
    if (typeof date === 'number') {
        date = new Date(date);
    }

    // 如果传入的是日期字符串，将其转换为日期对象
    if (typeof date === 'string') {
        // 解析日期字符串
        var match = /^(\d{4})-?(\d{2})-?(\d{2})$/.exec(date);
        if (match) {
            // 如果日期字符串符合 YYYY-MM-DD 格式，转换为日期对象
            date = new Date(parseInt(match[1]), parseInt(match[2]) - 1, parseInt(match[3]));
        } else {
            // 如果日期字符串不符合 YYYY-MM-DD 格式，尝试使用 Date.parse() 解析
            date = new Date(Date.parse(date));
        }
    }

    // 按照指定的格式生成日期字符串
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();

    var format = formatStr
        .replace(/YYYY/g, year)
        .replace(/MM/g, month.toString().padStart(2, '0'))
        .replace(/DD/g, day.toString().padStart(2, '0'));

    // 如果格式化字符串中包含连接符，则使用连接符 -
    if (formatStr.indexOf('-') >= 0) {
        format = format.replace(/-/g, '-');
    }

    return format;
}

/**
 * 时间转化 20250606 转成 2025-06-06
 * @param {} str
 * @returns
 */
export function formatDateToStr(str) {
    if (!/^\d{8}$/.test(str)) return ''; // 校验格式
    return `${str.slice(0, 4)}-${str.slice(4, 6)}-${str.slice(6, 8)}`;
}

/**
 * 时间 0930 转成 09:30
 * @param {*} str
 * @param {*} fill 补:0
 * @returns
 */
export function formatTimeToStr(str, fill = false) {
    // 判断str是否存在和有效
    if (!str) {
        return '';
    }
    if (str.indexOf(':') > -1) {
        return str;
    }
    if (!/^\d{4}$/.test(str)) return '';
    // 如果fill为true就补:00
    if (fill) {
        return `${str.slice(0, 2)}:${str.slice(2)}:00`;
    } else {
        return `${str.slice(0, 2)}:${str.slice(2)}`;
    }
}

/**
 *时间转化 202201011010 转成 2022-01-01 10:10
 *
 * @export
 * @param {*} dateTimeString
 * @return {*}
 */
export function formatDateTime(dateTimeString) {
    // 使用正则表达式将输入的日期时间字符串格式化为指定格式
    const formattedDateTime = dateTimeString.replace(
        /^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})$/,
        '$1-$2-$3 $4:$5'
    );

    // 返回格式化后的日期时间字符串
    return formattedDateTime;
}

/**
 * 修改股票,去除前缀
 * @param {} code
 * @returns
 */
export function cleanStockCode(code) {
    return code.replace(/^[A-Z]+/, '');
}

/**
 * 判断是否存在数字
 *
 * @export
 * @param {*} number
 */
export function formatNumber(number) {
    if (number) {
        return number;
    } else {
        return 0;
    }
}

/**
 * urlEncode
 *
 * @export
 * @param {*} str
 * @return {*}
 */
export function urlencode(str) {
    str = (str + '').toString();

    return encodeURIComponent(str)
        .replace(/!/g, '%21')
        .replace(/'/g, '%27')
        .replace(/\(/g, '%28')
        .replace(/\)/g, '%29')
        .replace(/\*/g, '%2A')
        .replace(/%20/g, '+');
}

/**
 *字符串转16进制
 *
 * @export
 * @param {*} str
 * @return {*}
 */
// export function strToHexCharCode(str) {
//   if (str === '') return '';
//   var hexCharCode = [];
//   // hexCharCode.push( "0x" );
//   const encoder = new TextEncoder();
//   const bytes = encoder.encode(str);
//   for (var i = 0; i < bytes.length; i++) {
//     // hexCharCode.push(str.charCodeAt(i).toString(16));
//     hexCharCode.push(bytes[i].toString(16));
//   }

//   return hexCharCode.join('');
// }

// 不兼容低版本ios
 export function strToHexCharCode(str) {
  if (str === '') return '';
  var hexCharCode = [];
  const encoder = new TextEncoder();
  const bytes = encoder.encode(str);
  for (var i = 0; i < bytes.length; i++) {
    // 使用两位十六进制表示每个字节
    var hex = bytes[i].toString(16).padStart(2, '0');
    hexCharCode.push(hex);
  }
  return hexCharCode.join('');
}

// export function strToHexCharCode(str) {
//     if (str === '') return '';
//     var hexCharCode = [];
//     for (var i = 0; i < str.length; i++) {
//         var hex = str.charCodeAt(i).toString(16).padStart(2, '0');
//         hexCharCode.push(hex);
//     }
//     return hexCharCode.join('');
// }


/**
 * 删除 数组里面 propertyName相等的 对象
 * propertyName 需要删除的字段名称
 * propertyValue 条件值
 * arr原始数组
 */
export function deleteObjectByProperty(propertyName, propertyValue, arr) {
    for (let i = 0; i < arr.length; i++) {
        if (arr[i][propertyName] === propertyValue) {
            arr.splice(i, 1);
            i--;
        }
    }
}

/**
 * 节流
 *
 */
export function jieliuFun(fn, delay) {
    var time = null,
        result; //被缓存
    return function () {
        let context = this; //记录一下this指向
        let args = arguments;
        //清除定时任务
        if (time) clearTimeout(time);
        time = setTimeout(function () {
            time = null;
            result = fn.apply(context, args);
        }, delay);
        return result;
    };
}

// 防抖
export function fangDouFun(fn, delay) {
    let time = null,
        result, // 缓存结果
        isFirstExecution = true; // 标记是否是第一次执行

    return function () {
        let context = this; // 记录一下 this 指向
        let args = arguments;

        if (isFirstExecution) {
            result = fn.apply(context, args);
            isFirstExecution = false;

            // 设置定时任务，在延迟时间结束后恢复 isFirstExecution 为 true
            time = setTimeout(function () {
                time = null; // 清空定时任务引用
                isFirstExecution = true;
            }, delay);
        } else {
            clearTimeout(time); // 清除之前的定时任务
            time = setTimeout(function () {
                result = fn.apply(context, args);
                time = null; // 清空定时任务引用
                isFirstExecution = true;
            }, delay);
        }

        return result;
    };
}

// 防抖
export function newFangDouFun(fn, delay) {
    let time = null,
        result; //被缓存
    return function () {
        let context = this; //记录一下this指向
        let args = arguments;
        //清除定时任务
        if (time) clearTimeout(time);
        time = setTimeout(function () {
            time = null;
            result = fn.apply(context, args);
        }, delay);
        return result;
    };
}

//组装父合集
export function fatherConvertDataToString(data, fatherConnector) {
    let result = '',
        key = 'ID';
    for (let i = 0; i < data.length; i++) {
        if (data[i].yzType == 0 || !data[i].yzType) {
            key = 'ID';
        } else {
            key = 'Info';
        }
        result += data[i][key];
        if (i < data.length - 1) {
            result += fatherConnector;
        }
    }
    return result;
}

//获取日期的前一天
export function getPreviousDay() {
    var currentDate = new Date();
    var previousDate = new Date(currentDate);
    previousDate.setDate(currentDate.getDate() - 1);

    var year = previousDate.getFullYear();
    var month = (previousDate.getMonth() + 1).toString().padStart(2, '0');
    var day = previousDate.getDate().toString().padStart(2, '0');

    var formattedDate = year + '-' + month + '-' + day;
    return formattedDate;
}
//获取日期的前一年
export function getPreviousYear() {
    let currentDate = new Date();
    let previousYearDate = new Date(
        currentDate.getFullYear() - 1,
        currentDate.getMonth(),
        currentDate.getDate()
    );

    let year = previousYearDate.getFullYear();
    let month = String(previousYearDate.getMonth() + 1).padStart(2, '0');
    let day = String(previousYearDate.getDate()).padStart(2, '0');

    return year + '-' + month + '-' + day;
}

//如果是今日内的调仓记录，则只显示时间分钟（xx:xx），昨天往前的调仓记录，显示日期+时间（xxxx-xx-xx xx:xx）
export function formatTradeRecordDate(inputDate) {
    // 将传入的日期字符串转换为 Date 对象
    const tradeDate = new Date(inputDate.replace(/-/g, '/'));

    // 检查日期对象是否有效
    if (isNaN(tradeDate.getTime())) {
        // 如果日期对象无效，返回 '--:--'
        return '--:--';
    }

    // 获取当前日期
    const currentDate = new Date();

    // 检查是否是今天
    if (tradeDate.toDateString() === currentDate.toDateString()) {
        // 如果是今天，只显示时间分钟（xx:xx）
        const hours = tradeDate.getHours().toString().padStart(2, '0');
        const minutes = tradeDate.getMinutes().toString().padStart(2, '0');
        return `${hours}:${minutes}`;
    } else {
        // 如果不是今天，显示日期+时间（xxxx-xx-xx xx:xx）
        return inputDate;
    }
}

/**
 * 判断版本号(新版)
 * @param {string} version1 - 第一个版本号
 * @param {string} version2 - 第二个版本号
 * @returns {number} - 返回版本号比较结果，0表示相等，1表示第一个版本号大于第二个版本号，-1表示第一个版本号小于第二个版本号
 * @returns {boolean} - 返回版本号比较结果，true表示第一个版本号大于或者等于第二个版本号，false表示第一个版本号小于第二个版本号
 *
 */
export function compareVersions(currentVersion, needVersion) {
    currentVersion = currentVersion ? currentVersion.toString() : '9.00';
    needVersion = needVersion ? needVersion.toString() : '9.00';
    // 判断是否是鸿蒙
    if (getMobileOSType() == 4) {
        needVersion = '2.05';
    }

    // 标准化版本号
    const version1 = normalizeVersion(currentVersion);
    const version2 = normalizeVersion(needVersion);

    // 将版本号按"."分割成数组
    const v1Parts = version1.split('.');
    const v2Parts = version2.split('.');

    const length = Math.max(v1Parts.length, v2Parts.length);

    // 定义比较结果
    let result = 0;

    // 比较每个部分
    for (let i = 0; i < length; i++) {
        // 如果某个版本号部分不存在，填充为0
        const v1Part = parseInt(v1Parts[i] || '0', 10);
        const v2Part = parseInt(v2Parts[i] || '0', 10);

        if (v1Part > v2Part) {
            result = 1; // version1 is greater than version2
            // 结束循环
            break;
        } else if (v1Part < v2Part) {
            result = -1; // version1 is smaller than version2
            // 结束循环
            break;
        }
    }

    if (result >= 0) {
        return true;
    } else {
        return false;
    }
}
/**
 * // 因子组合转编码(交并集)
 * @param {*} parentFactorList 父级组合
 * @param {*} sonFactorList 子集组合
 * @param {*} checkedYzType 类型: jj-交集 bj-并集
 */
export function factorCombinationToCode(
    parentFactorList = [],
    sonFactorList = [],
    checkedYzType = 'jj'
) {
    console.log('parentFactorList', parentFactorList);
    console.log('sonFactorList', sonFactorList);
    console.log('checkedYzType', checkedYzType);

    var list1 = [];
    var list2 = [];
    if (checkedYzType == 'jj') {
        // 存在父级组合
        list1 = parentFactorList.map((obj) => {
            // 0-普通因子(需要做"非"的判断) 4-自定义因子(大智慧)需要做加密处理 其他直接用Info即可
            if (obj.yzType != 0) {
                //自选和模版的取info字段 其他的直接取id
                if (obj.yzType == 4) {
                    return '&F' + strToHexCharCode(obj.Info);
                } else {
                    return '&' + obj.Info;
                }
            } else {
                if (obj.isNon) {
                    return '&!' + obj.ID;
                } else {
                    return '&' + obj.ID;
                }
            }
        });
        // 如果存在子集
        if (sonFactorList.length > 0) {
            list2 = sonFactorList
                .filter((group) => group && group.length > 0) // 安全过滤：防止有空数组报错
                .map((group) => {
                    // 取出组内所有 ID 并用 | 连接 -> "ID|ID"
                    const ids = group
                        .map((item) => {
                            if (item.yzType !== 0) {
                                //自选和模版的取info字段 其他的直接取id
                                if (item.yzType == 4) {
                                    return 'F' + strToHexCharCode(item.Info);
                                } else {
                                    return item.Info;
                                }
                            } else {
                                if (item.isNon) {
                                    return '!' + item.ID;
                                } else {
                                    return item.ID;
                                }
                            }
                        })
                        .join('|');
                    // 加上前缀 & -> "&ID|ID"
                    return `&${ids}`;
                });
        }
    } else {
        // 存在父级组合
        list1 = parentFactorList.map((obj) => {
            // 0-普通因子(需要做"非"的判断) 4-自定义因子(大智慧)需要做加密处理 其他直接用Info即可
            if (obj.yzType != 0) {
                //自选和模版的取info字段 其他的直接取id
                if (obj.yzType == 4) {
                    return '|F' + strToHexCharCode(obj.Info);
                } else {
                    return '|' + obj.Info;
                }
            } else {
                if (obj.isNon) {
                    return '|!' + obj.ID;
                } else {
                    return '|' + obj.ID;
                }
            }
        });
        // 如果存在子集
        if (sonFactorList.length > 0) {
            list2 = sonFactorList
                .filter((group) => group && group.length > 0) // 安全过滤：防止有空数组报错
                .map((group) => {
                    // 取出组内所有 ID 并用 | 连接 -> "ID|ID"
                    const ids = group
                        .map((item) => {
                            if (item.yzType !== 0) {
                                //自选和模版的取info字段 其他的直接取id
                                if (item.yzType == 4) {
                                    return 'F' + strToHexCharCode(item.Info);
                                } else {
                                    return item.Info;
                                }
                            } else {
                                if (item.isNon) {
                                    return '!' + item.ID;
                                } else {
                                    return item.ID;
                                }
                            }
                        })
                        .join('&');
                    // 加上前缀 & -> "&ID|ID"
                    return `|${ids}`;
                });
        }
    }

    console.log('list1', list1);
    console.log('list2', list2);
    // 3. 合并两个数组
    const finalResult = [...list1, ...list2];
    console.log('finalResult', finalResult);
    var hexyzIds = ':' + strToHexCharCode(':' + finalResult.join(''));

    var returnData = {
        hexyzIds: hexyzIds, // 因子编码之后的数据
        idArrayToStr : parseCollectionCondition(parentFactorList,sonFactorList)
    }
    return returnData;
}
// 拆解组合结构
export function parseCollectionCondition(yzList,children) {
    const allIds = [
        // 1. 取出 arr1 的 ID
        ...yzList.map(item => {
            if (item.yzType != 0) {
                //自选和模版的取info字段 其他的直接取id
                if (item.yzType == 4) {
                    return 'F' + strToHexCharCode(item.Info);
                } else {
                    return item.Info;
                }
            } else {
                if (item.isNon) {
                    return item.ID;
                } else {
                    return item.ID;
                }
            }
        }),

        // 2. 先拍平 arr2 (二维变一维)，再取出 ID
        ...children.flat().map(item => {
            if (item.yzType !== 0) {
                //自选和模版的取info字段 其他的直接取id
                if (item.yzType == 4) {
                    return 'F' + strToHexCharCode(item.Info);
                } else {
                    return item.Info;
                }
            } else {
                if (item.isNon) {
                    return item.ID;
                } else {
                    return item.ID;
                }
            }
        })
    ];
    return allIds.toString();
}


function getMobileOSType() {
    const ua = navigator.userAgent || navigator.vendor || window.opera;

    const isIOS = /iPhone|iPad|iPod/i.test(ua);
    const isAndroid = /Android/i.test(ua);
    const isHarmony = /dzhhmtablet ohos|ohos|dzhapp ohos|dzhhm2in1 ohos/i.test(ua);

    if (isHarmony) return 4; // 移动鸿蒙终端
    if (isIOS) return 2; // 移动 iOS 终端
    if (isAndroid) return 3; // 移动 Android 终端

    return 1; // pc
}

function normalizeVersion(version) {
    // 将版本号按"."分割成数组
    const parts = version.split('.');
    // 确保数组长度为3，不足则补0
    while (parts.length < 3) {
        parts.push('0');
    }
    // 返回标准化的版本号
    return parts.join('.');
}

// 获取因子组合内的名称
export function getFactorNames(data) {
    const factorNames = [];

	function extractFactorNames(obj) {
		if (Array.isArray(obj)) {
			for (const item of obj) {
				extractFactorNames(item);
			}
		} else if (typeof obj === "object" && obj !== null) {
			if ("FactorName" in obj) {
				factorNames.push(obj.FactorName);
			}
			for (const key in obj) {
				extractFactorNames(obj[key]);
			}
		}
	}

	extractFactorNames(data);

	return factorNames;
}
